// Hideo - HTML pieces for the code that writes HTML strings (v-html, the editor's menus): escaping, safe links, the
// round social links. Ported from the legacy core/utils.js (verbatim copies in tests/fixtures/legacy/utils.js and
// utils-w12.js; tests/utils.test.ts compares the outputs).
import { normUrl } from './url'

/** Escapes & < > " ' for HTML text and attribute values */
export const esc = (s: unknown): string =>
  String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string)

/** Value for href: only http(s) addresses (escaped), otherwise '#' */
export const safeHref = (u: string): string => /^https?:\/\//i.test(u) ? esc(u) : '#'

/** Social accounts a creator or a profile may have (the stored field holds the address or the handle typed) */
interface SocialAccounts { youtube?: string; instagram?: string; tiktok?: string; twitch?: string }

/** Round links to a creator's or a profile's YouTube, Instagram, TikTok and Twitch (HTML): size = the circle's classes,
 *  icon = classes added to the icon. In a clickable row, the element holding them gets @click="stopLinkClick" */
export function socialLinks(c: SocialAccounts, size: string, icon: string): string {
  return ([['youtube', 'fa-youtube'], ['instagram', 'fa-instagram'], ['tiktok', 'fa-tiktok'], ['twitch', 'fa-twitch']] as const).filter(([k]) => c[k]).map(([k, i]) =>
    `<a href="${safeHref(normUrl(c[k]))}" target="_blank" rel="noopener" class="bg-darkbtn hover:bg-brand text-gray-300 hover:text-white ${size} rounded-full flex items-center justify-center transition"><i class="fab ${i}${icon}"></i></a>`).join('')
}
/** A click on a link drawn inside the element (the social links of a clickable row) does not reach the row around it
 *  (the browser still opens the link), as the links' former inline handler did */
export function stopLinkClick(e: Event): void {
  const a = (e.target as Element).closest('a')
  if (a && (e.currentTarget as Element).contains(a)) e.stopPropagation()
}
